<template>
  <div class="route-info">
    <img :src="routeInfo.listImage" />
    <div class="route-info-detail">
      <div class="title">{{ routeInfo.title }}</div>
      <div class="bottom">
        <div class="cities-container">
          <span class="location" />
          <span v-for="(city, index) in routeInfo.cities" :key="index" class="city">{{ city }}</span>
        </div>
        <div class="detail-btn" @click="handleToRouteDetail">
          查看路线详情
          <img src="../../../../assets/images/icon_roadtrip_arrow.png" class="icon-road-trip" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "RouteListItem",
  props: {
    routeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters("activityInfo", ["activityId"])
  },
  methods: {
    handleToRouteDetail() {
      const query = {
        id: this.activityId,
        rid: this.routeInfo.id
      }
      const shopId = this.$route.query?.shopId
      if (shopId) {
        query.shopId = shopId
      }
      this.$router.push({
          path: "/recommendRouteDetail",
          query
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.route-info {
  display: flex;
  align-items: center;
  height: 1.8rem;
  width: 100%;
  margin-top: 0.3rem;
  margin-bottom: 0.4rem;
  overflow: hidden;

  & > img {
    width: 1.8rem;
    height: 1.8rem;
    object-fit: cover;
    border-radius: 0.14rem;
  }
}

.route-info-detail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: calc(100% - 2rem);
  margin-left: 0.2rem;

  .title {
    font-size: 0.34rem;
    color: #333333;
    line-height: normal;
    font-weight: 600;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    font-size: 0.24rem;

    .cities-container {
      width: 0;
      flex: 1;
      height: 0.33rem;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-box-pack: center;
    }

    .location {
      flex-shrink: 0;
      display: inline-flex;
      width: 0.18rem;
      height: 0.24rem;
      margin-right: 0.1rem;
      background: url('../../../../assets/images/icon_location.png') no-repeat;
      background-size: contain;
      vertical-align: middle;
    }

    .city {
      flex-shrink: 0;
      display: inline-flex;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
      margin-right: 0.1rem;
      vertical-align: middle;
    }

    .detail-btn {
      display: flex;
      align-items: center;
      width: auto;
      height: 0.56rem;
      box-sizing: border-box;
      padding: 0.1rem 0.2rem;
      background-image: linear-gradient(180deg, #FF601A 0%, #DC0808 100%);
      border-radius: 0.30rem;
      font-family: PingFang-SC-Bold;
      font-size: 0.26rem;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 700;
      flex-shrink: 0;

      .icon-road-trip {
        width: 0.2216rem;
        height: 0.2412rem;
        object-fit: contain;
        margin-left: 0.14rem;
      }
    }
  }
}
</style>
